module.exports = __webpack_public_path__ + "img/NOTE-alt.87881b5b.svg";